var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStationary = function SvgStationary(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14814_2835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 72.5063V0.506348H61.0236V72.5063H10Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.834 69.6716V10.7109H58.1883V69.6716H12.834Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.13386
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.834 10.7109V3.34082H58.1883V10.7109H12.834Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.13386
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9363 3.34082H23.0387L17.9363 10.7109H12.834L17.9363 3.34082Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5597 3.34082H34.9455L29.5597 10.7109H24.1738L29.5597 3.34082Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1836 24.8841V14.6794L19.0709 24.8841V35.0889L35.1836 24.8841Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1836 24.8841V14.6794L53.0866 24.8841V35.0889L35.1836 24.8841Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1816 40.1913V29.9865L19.0689 40.1913V50.396L35.1816 40.1913Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1816 40.1913V29.9865L53.0847 40.1913V50.396L35.1816 40.1913Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1816 55.4984V45.2937L19.0689 55.4984V65.7031L35.1816 55.4984Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1816 55.4984V45.2937L53.0847 55.4984V65.7031L35.1816 55.4984Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.464 3.34082H46.8498L41.464 10.7109H36.0781L41.464 3.34082Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0867 3.34082H58.1891L53.0867 10.7109H47.9844L53.0867 3.34082Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14814_2835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStationary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "stationary.4198d8321a4240338f9c214306a49cfd.svg";